import React from "react"
import { FaChevronUp } from "react-icons/fa"

import classes from "./DpTopButtons.module.scss"

const DpTopButtons = props => {
  const {
    type,
    timeRangeStep,
    timeRange,
    setTimeRange,
    selectedTime,
    setSelectedTime
  } = props

  const handleIncreaseHour = () => {
    const hourNumber = Number(selectedTime.hours)
    let newHour = hourNumber + 1
    newHour = newHour === 24 ? 0 : newHour
    if (newHour < 10) newHour = `0${newHour}`

    setSelectedTime(prev => ({ ...prev, hours: newHour }))
  }

  const handleIncreaseMinute = () => {
    const minuteNumber = Number(selectedTime.minutes)
    let newMinutes = minuteNumber + 1
    newMinutes = newMinutes === 60 ? 0 : newMinutes
    if (newMinutes < 10) newMinutes = `0${newMinutes}`

    setSelectedTime(prev => ({
      ...prev,
      minutes: newMinutes
    }))
  }

  const handleIncreaseHourRange = () => {
    const index = timeRangeStep === "start" ? 0 : 1
    const hourNumber = Number(timeRange[index].hours)
    let newHour = hourNumber + 1
    newHour = newHour === 24 ? 0 : newHour

    setTimeRange(prev => {
      const array = [...prev]
      array[index].hours = newHour < 10 ? `0${newHour}` : newHour

      if (newHour === 24) array[index].minutes = "00"

      return array
    })
  }

  const handleIncreaseMinuteRange = () => {
    const index = timeRangeStep === "start" ? 0 : 1
    const minuteNumber = Number(timeRange[index].minutes)

    let newMinutes = minuteNumber + 1
    newMinutes = newMinutes === 60 ? 0 : newMinutes

    if (newMinutes < 10) newMinutes = `0${newMinutes}`

    setTimeRange(prev => {
      const array = [...prev]
      array[index].minutes = newMinutes
      return array
    })
  }

  return (
    <div className={classes["row"]}>
      <div
        className={classes["button"]}
        onClick={
          type === "rangeTimePicker" ?
            handleIncreaseHourRange :
            handleIncreaseHour
        }
      >
        <FaChevronUp />{" "}
      </div>
      <div
        className={classes["button"]}
        onClick={
          type === "rangeTimePicker" ?
            handleIncreaseMinuteRange :
            handleIncreaseMinute
        }
      >
        <FaChevronUp />
      </div>
    </div>
  )
}

export default DpTopButtons